/*
WR 威廉指标
WR1:100*(HHV(HIGH,N)-CLOSE)/(HHV(HIGH,N)-LLV(LOW,N));
（N天内最高价-当日的收盘价）/(N天内的最高价-N天内的最低价)

WR2:100*(HHV(HIGH,N1)-CLOSE)/(HHV(HIGH,N1)-LLV(LOW,N1));

默认参数：N= 10.00，N1=6
*/

import BaseContext from '../basecontext';
import FootDectorator from '../dectorator/footdectorator';
import { checkFootAuth, checkFootTitleAuth } from '../dectorator/checkauthdectorator/index.js';
import Util, { mergeModelData, curryFun } from '../../util/index.js';
import { checkExchange } from '../../controller/util.js';
import { LINE_TYPE } from '../setting.js';
const model = {
    wr6: {
        Type: Array,
        Default: () => ([])
    },
    wr10: {
        Type: Array,
        Default: () => ([])
    },
    params: {
        Type: String,
        Default: 'WR(10,6)'
    }
}
export default class WRState extends FootDectorator(BaseContext) {
    constructor({ data, ...rest }) {
        super({ ...rest, data: mergeModelData(model, data) });
    }
    _calcRange() {
        let { wr6, wr10, code, params } = this.state.data
        let { maxValue, minValue } = this.calcRange({ data: [wr6, wr10], targetKey: 'value', isAdditional: true })
      // if (maxValue === minValue) {
      //   if (maxValue === 0) {
      //     maxValue = 1;
      //     minValue = -1;
      //   } else if (maxValue === 100) {
      //     maxValue = 150;
      //     minValue = 50;
      //   }
      // } else {
      //   const ratioVal = maxValue * 0.05;
      //   maxValue += ratioVal;
      //   minValue -= ratioVal;
      // }
      this.maxValue = maxValue;
      this.minValue = minValue;
    }
    _calcAxis() {
        const maxValue = this.maxValue;
        const range = maxValue * 2;
        const {
            height
        } = this.availArea;
        const ratio = height / range;
        const { wr6, wr10, start, end } = this.state.data
        const curryCalcAxis = curryFun(this.calcAxis, this, {
            targetKey: 'value',
            sourceKey: 'lineY',
            isAdditional: true,
        });
        curryCalcAxis({ data: wr6 });
        curryCalcAxis({ data: wr10 })
    }
    // 画主图
    _drawMain() {
        const {
            left,
            width,
            height,
            top,
            bottom,
        } = this.availArea;
        const { wr6, wr10 } = this.state.data
        const { LINE } = LINE_TYPE;
        const { wr6: wr6Line, wr10: wr10Line } = this.option.Wr
        this._drawLine(LINE, wr6, left, bottom, wr6Line.lineWidth, wr6Line.color)
        this._drawLine(LINE, wr10, left, bottom, wr10Line.lineWidth, wr10Line.color)
    }
    _drawAxisY() {
        const { axisY } = this.option.Wr;
        const {
            left,
            right,
            top,
            bottom,
            height
        } = this.availArea;
        const ctx = this.context;
        const maxValue = this.maxValue;
        const minValue = this.minValue;
        // const line=((Math.abs(maxValue)+Math.abs(minValue))/2+minValue).toFixed(2)
      let line;
      if(maxValue>0&&minValue<0){
        line=((Math.abs(maxValue)+Math.abs(minValue))/2+minValue).toFixed(2)
      }else if(maxValue<0&&minValue<0) {
        line=((Math.abs(minValue)-Math.abs(maxValue))/2+minValue).toFixed(2)
      }else {
        line=((Math.abs(maxValue)-Math.abs(minValue))/2+minValue).toFixed(2)
      }
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        ctx.fillStyle = axisY.color;
        ctx.font = axisY.sizeRatio * this.state.baseSize * this.dpr + "px " + axisY.fontFamily;
        ctx.fillText(this.maxValue.toFixed(2), left, top+20);
        ctx.textBaseline = 'middle';
        ctx.fillText(line, left, top + height / 2);
        ctx.textBaseline = 'bottom';
        ctx.fillText(this.minValue.toFixed(2), left, bottom);
    }
    _drawTitle() {
        const ctx2 = this.curContext;
        const { top } = this.availArea;
        const { current, sealObj, len } = this.state.data;
        const { height, baseSize } = this.state;
        const { ratioFixed } = sealObj;
        const { space } = this.option.Wr;
        const { baseLine } = this.option.FootContext.title;
        const baseLineY = top + height * baseLine;
        let { left } = this.availArea;
        // left+=ctx2.measureText(this.maxValue.toFixed(2)).width+10
        const {
            sizeRatio,
            fontFamily,
            axisY,
        } = this.option.Wr;
        [
            'params',
            'wr6',
            'wr10'
        ].forEach(val => {
            const data = this.state.data[val];
            if (data == 'WR(10,6)') {
                let color = this.option.Wr.params.color
                ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
                ctx2.fillStyle = color;
                ctx2.textAlign = 'left';
                ctx2.textBaseline = 'top';
                ctx2.beginPath();
                const text = data
                const textWidth = ctx2.measureText(text).width;
                ctx2.fillText(text, left, baseLineY);
                left += textWidth + 10;

            } else {
                if (Util.isArray(data)) {
                    let color = this.option.Wr[val].color;
                    const item = data[current];
                    ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
                    ctx2.fillStyle = color;
                    ctx2.textAlign = 'left'
                    ctx2.textBaseline = 'top';
                    ctx2.beginPath();
                    if (Util.isDef(item) && Util.isValidNumber(item.value)) {
                        // 吧字符串转换为大写
                        const text = val.toUpperCase() + ':' + item.value.toFixed(ratioFixed);
                        const textWidth = ctx2.measureText(text).width
                        ctx2.fillText(text, left, baseLineY);
                        left += textWidth

                    } else {
                        const text = val.toUpperCase() + ': -';
                        const textWidth = ctx2.measureText(text).width;
                        ctx2.fillText(text, left, baseLineY);
                        left += textWidth;
                    }
                    left += space * this.dpr;
                }

            }




        })

    }




}
/*
WR 威廉指标
WR1:100*(HHV(HIGH,N)-CLOSE)/(HHV(HIGH,N)-LLV(LOW,N));
（N天内最高价-当日的收盘价）/(N天内的最高价-N天内的最低价)

WR2:100*(HHV(HIGH,N1)-CLOSE)/(HHV(HIGH,N1)-LLV(LOW,N1));

默认参数：N= 10.00，N1=6
*/
